
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Am 6. Juni wurden die Schweizer Covid-19-Massnahmen weiter gelockert. Höchstens
eine von zehn Personen hat sich hierzulande mit dem Coronavirus angesteckt –
allen anderen fehlt somit jegliche Immunität, und neue Ausbrüche sind weiterhin
möglich.`}</p>
    <p>{`Um die Ausbreitung langfristig zu kontrollieren, müssen Verdachtsfälle
`}<strong parentName="p">{`getestet`}</strong>{`, `}<strong parentName="p">{`isoliert`}</strong>{` und `}<strong parentName="p">{`Kontaktpersonen in Quarantäne`}</strong>{` versetzt
werden, `}<a parentName="p" {...{
        "href": "https://smw.ch/article/doi/smw.2020.20225"
      }}>{`sagen Experten`}</a>{`.
Mittlerweile verfolgen auch der Bund und die Kantone diese Strategie. Um dies zu
erreichen, ist die Ermittlung von Kontaktpersonen unerlässlich – durch das
sogenannte `}<em parentName="p">{`Contact-Tracing`}</em>{`. Die Installation der App «SwissCovid» des Bundes
soll dabei helfen. Sie ist ab dem 25. Juni im Apple Store und Google Play Store
verfügbar. Deutschland, Österreich und Italien haben schon ähnliche `}<em parentName="p">{`Proximity
Tracing Apps`}</em>{` lanciert.`}</p>
    <p>{`Hier erfahren Sie, warum es aus epidemiologischer Sicht Sinn macht, eine solche
App zu installieren.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;